import { render, staticRenderFns } from "./UsageClinicalColumnChart.vue?vue&type=template&id=1d0ffc3a"
import script from "./UsageClinicalColumnChart.vue?vue&type=script&lang=js"
export * from "./UsageClinicalColumnChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports